
export default [
 {
   "value": "基市",
   "label": "基隆市"
 },
 {
   "value": "北市",
   "label": "台北市"
 },
 {
   "value": "新北市",
   "label": "新北市"
 },
 {
   "value": "北縣",
   "label": "台北縣"
 },
 {
   "value": "桃市",
   "label": "桃園市"
 },
 {
   "value": "桃縣",
   "label": "桃園縣"
 },
 {
   "value": "竹市",
   "label": "新竹市"
 },
 {
   "value": "竹縣",
   "label": "新竹縣"
 },
 {
   "value": "苗縣",
   "label": "苗栗縣"
 },
 {
   "value": "中市",
   "label": "台中市"
 },
 {
   "value": "中縣",
   "label": "台中縣"
 },
 {
   "value": "彰縣",
   "label": "彰化縣"
 },
 {
   "value": "投縣",
   "label": "南投縣"
 },
 {
   "value": "雲縣",
   "label": "雲林縣"
 },
 {
   "value": "嘉市",
   "label": "嘉義市"
 },
 {
   "value": "嘉縣",
   "label": "嘉義縣"
 },
 {
   "value": "南市",
   "label": "台南市"
 },
 {
   "value": "南縣",
   "label": "台南縣"
 },
 {
   "value": "高市",
   "label": "高雄市"
 },
 {
   "value": "高縣",
   "label": "高雄縣"
 },
 {
   "value": "屏縣",
   "label": "屏東縣"
 },
 {
   "value": "宜縣",
   "label": "宜蘭縣"
 },
 {
   "value": "花縣",
   "label": "花蓮縣"
 },
 {
   "value": "東縣",
   "label": "台東縣"
 },
 {
   "value": "連江",
   "label": "連江線"
 },
 {
   "value": "金門",
   "label": "金門線"
 },
 {
   "value": "澎縣",
   "label": "澎湖縣"
 }
]